import { createSelector } from 'reselect';
import { RootState } from 'store/types';

const authSliceSelector = (state: RootState) => state.auth;

export const authState = createSelector(authSliceSelector, (state) => ({
  ...state,
  isAuthenticated: !!state.userData?.email
}));
